import Section from '../ui/Section';
import styles from './Media.module.css';

const roles = [
  { title: 'Radio/TV Personality', desc: 'Top 30 Radio Personality in the country, eight consecutive years.' },
  { title: 'Party DJ/Host', desc: 'High-energy host for concerts, community events, and celebrity functions.' },
  { title: 'Podcaster', desc: 'Conversations at the intersection of music, culture, and community.' }
];

export default function Media() {
  return (
    <Section id="personality" eyebrow="Media" title="On air. On stage. On record.">
      <div className={styles.cards}>
        {roles.map((role) => (
          <div key={role.title} className={styles.card}>
            <h3 className={styles.cardTitle}>{role.title}</h3>
            <p className={styles.cardDesc}>{role.desc}</p>
          </div>
        ))}
      </div>
      <p>
        Voted a Top 30 Radio Personality in the country by Source Magazine (Hip Hop Bible) for eight
        consecutive years. Twenty-five years of entertainment experience has made Brian one of the
        most sought-after talents on the East Coast. Brian is the afternoon drive host (3pm&ndash;7pm)
        for Radio One Raleigh WQOK FM K97.5. His show &ldquo;RockStarRadio&rdquo; can be heard
        throughout central parts of North Carolina to Southern Virginia and has been consistently
        ranked number one in the 12+, 18&ndash;34, and 25&ndash;54 demos.
      </p>
    </Section>
  );
}
